import { render, staticRenderFns } from "./Subpost.vue?vue&type=template&id=064d8286&"
import script from "./Subpost.vue?vue&type=script&lang=js&"
export * from "./Subpost.vue?vue&type=script&lang=js&"
import style0 from "./Subpost.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports